import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { getAllStandortNamen } from "../../api/admin-management-api";

interface DashboardDialogFilterProps {
  showDateFilter: boolean;
  onFilterChange: (filters: {
    date: string | null;
    standort: number;
  }) => Promise<void>;
}

interface FilterObj {
  year: number;
  month: number;
  idStandort: number | "";
}

export const DashboardDialogFilter: React.FC<DashboardDialogFilterProps> = ({
  showDateFilter,
  onFilterChange,
}) => {
  const [filterObj, setFilterObj] = useState<FilterObj>({
    year: null,
    month: null,
    idStandort: "",
  });

  const [standorte, setStandorte] = useState<{ id: number; name: string }[]>(
    []
  );

  /* eslint-disable */
  useEffect(() => {
    async function loadStandorte() {
      try {
        const data = await getAllStandortNamen();
        setStandorte(data.map((v) => ({ id: v.ID, name: v.data })));
      } catch (err) {
        console.error("Fehler beim Laden der Standorte:", err);
      }
    }
    loadStandorte();
  }, []);

  useEffect(() => {
    let idStandort: number | undefined;
    let filterDate: string | null = null;

    // Only set date if both year and month are set
    if (filterObj.year !== null && filterObj.month !== null) {
      filterDate = new Date(filterObj.year, filterObj.month, 1).toISOString();
    }

    if (filterObj.idStandort !== "") {
      idStandort = filterObj.idStandort;
    }

    onFilterChange({
      date: showDateFilter ? filterDate : null,
      standort: idStandort,
    });
  }, [filterObj, showDateFilter]);
  /* eslint-enable */

  return (
    <div className="flex flex-col gap-4 mb-4">
      {showDateFilter && (
        <div className="flex gap-4">
          {/* Monat */}
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="month-label">Monat</InputLabel>
            <Select
              labelId="month-label"
              value={filterObj.month ?? ""}
              label="Monat"
              onChange={async (e: SelectChangeEvent<number | "">) => {
                console.log(e.target.value);
                const value =
                  e.target.value === "" ? null : Number(e.target.value);
                setFilterObj((prevState) => ({
                  ...prevState,
                  month: value,
                }));
              }}
            >
              <MenuItem value="">
                <em>--</em>
              </MenuItem>
              {Array.from({ length: 12 }).map((_, idx) => (
                <MenuItem key={idx} value={idx}>
                  {new Date(0, idx).toLocaleString("de-DE", { month: "long" })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Jahr */}
          <FormControl size="small" sx={{ minWidth: 100, pb: 2 }}>
            <InputLabel id="year-label">Jahr</InputLabel>
            <Select
              labelId="year-label"
              value={filterObj.year ?? ""}
              label="Jahr"
              onChange={async (e: SelectChangeEvent<number | "">) => {
                const value =
                  e.target.value === "" ? null : Number(e.target.value);
                setFilterObj((prevState) => ({
                  ...prevState,
                  year: value,
                }));
              }}
            >
              <MenuItem value="">
                <em>--</em>
              </MenuItem>
              {Array.from({ length: 4 }).map((_, idx) => {
                const year = new Date().getFullYear() - 2 + idx;
                return (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      )}

      {/* Standort */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="standort-label">Standort</InputLabel>
        <Select
          labelId="standort-label"
          value={filterObj.idStandort}
          label="Standort"
          onChange={async (e: SelectChangeEvent<number | "">) => {
            const value = e.target.value === "" ? "" : Number(e.target.value);
            setFilterObj((prevState) => ({
              ...prevState,
              idStandort: value,
            }));
          }}
        >
          <MenuItem value="">
            <em>Alle</em>
          </MenuItem>
          {standorte.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
